import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { BrowserUtils } from '@azure/msal-browser';
import { DementiaSeriesComponent } from './components/dementia-series/dementia-series.component';
import { EErgoDashboardComponent } from './components/e-ergo-dashboard/e-ergo-dashboard.component';
import { EErgoHomeComponent } from './components/e-ergo-home/e-ergo-home.component';
import { ManualMaterialHandlingComponent } from './components/e-ergo-templates/manual-material-handling/manual-material-handling.component';
import { OfficeErgonomicsComponent } from './components/e-ergo-templates/office-ergonomics/office-ergonomics.component';
import { FailedComponent } from './components/failed/failed.component';
import { HomeComponent } from './components/home/home.component';
import { IndustryResourcePageComponent } from './components/industry-resource-page/industry-resource-page.component';
import { MemicMinutesComponent } from './components/memic-minutes/memic-minutes.component';
import { ResourceLibraryComponent } from './components/resource-library/resource-library.component';
import { WebinarsOnDemandCardComponent } from './components/webinars-on-demand-card/webinars-on-demand-card.component';
import { FavoriteResourcesComponent } from './components/favorite-resources/favorite-resources.component';

const routes: Routes = [
  {
    path: 'home',
    component: HomeComponent    
  },
  {
    path: 'resource-library',
    component: ResourceLibraryComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'favorite-resources',
    component: FavoriteResourcesComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'dementia-series',
    component: DementiaSeriesComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'memic-minutes',
    component: MemicMinutesComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'webinars-on-demand',
    component: WebinarsOnDemandCardComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'industry-resources/:industry',
    component: IndustryResourcePageComponent,
    runGuardsAndResolvers: 'paramsChange',
    canActivate: [MsalGuard]
  },
  {
    path: 'e-ergo',
    data: { breadcrumb: 'E-Ergo', },
    component: EErgoHomeComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'e-ergo-dashboard',
    data: { breadcrumb: 'Dashboard', },
    component: EErgoDashboardComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'office-ergonomics/:formId',
    component: OfficeErgonomicsComponent,
    canActivate: [MsalGuard]
  },
  {
    path: 'manual-material-handling/:formId',
    component: ManualMaterialHandlingComponent,
    canActivate: [MsalGuard]
  },
  {
    path: '**',
    redirectTo: 'home',
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'login-failed',
    component: FailedComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    useHash: true,
    onSameUrlNavigation: 'reload',
    // Don't perform initial navigation in iframes or popups
    initialNavigation: !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup() ? 'enabledNonBlocking' : 'disabled' // Set to enabledBlocking to use Angular Universal
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
